import React from "react"
import ReactDOM from "react-dom"
import "./index.css"
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import { configureAccessManagement } from "./startup/authn"
import { BrowserRouter as Router } from "react-router-dom"
import { ClientConfig } from "./config"

const config = {
  clientId: process.env.REACT_APP_CLIENTID!,
  redirectUri: process.env.REACT_APP_REDIRECTURI || window.location.origin,
  tenant: process.env.REACT_APP_TENANT!,
  tenantId: process.env.REACT_APP_TENANTID!,
  policyId: process.env.REACT_APP_POLICYID!,
}

configureAccessManagement(config.tenant, config.policyId, config.clientId, config.redirectUri)

ReactDOM.render(<ClientConfig config={config}><Router><App /></Router></ClientConfig>, document.getElementById("root"))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
